<template>
    <div class="whatsapp-icon">
        <a :href="'https://wa.me/'+init_data.phone+'?text='+init_data.text" target="_blank">
            <b-img class="wapp_icon" :src="require('@/assets/img/wapp.png')" alt="WhatsApp"></b-img>
        </a>
        <b-button variant="success" class="shadow text-white" :href="'https://wa.me/'+init_data.phone+'?text='+init_data.text" target="_blank"> {{init_data.label}}</b-button>
  </div>
</template>

<script>
import Vue from 'vue'

    export default Vue.extend({
        name: 'WhatsAppIcon',
        props: {
            init_data: { type: Object, default: () => ({}) },
        },
    })
</script>

<style lang="scss" scoped>
    @import '../../styles/app';

    img.wapp_icon {
        height: 2rem !important;
    }

    .whatsapp-icon {
        position: relative;
        left: 2px;

        @include media-breakpoint-down(sm) {
            left: 2px;
        }
        @include media-breakpoint-up(sm) {
            left: 2px;
        }
        @include media-breakpoint-up(lg) {
            left: 2px;
        }
    }

    .whatsapp-icon a {
        font-size: .7rem !important;

        @include media-breakpoint-down(sm) {
            font-size: 0.5rem !important;
        }
        @include media-breakpoint-up(sm) {
            font-size: 0.6rem !important;
        }
        @include media-breakpoint-up(lg) {
            font-size: .8rem !important;
        }
    }

</style>